import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../Styles/ViewFaculty.css";
import Loader from "../../Components/Loader";

function ViewStudents() {
    const [faculties, setFaculties] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredAdmins, setFilteredAdmins] = useState([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(15);

    useEffect(() => {
        const fetchFaculties = async () => {
            const authToken = localStorage.getItem("authToken");

            try {
                setLoading(true);
                const response = await axios.get("https://api.uniums.com/api/admin/students", {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                });

                setFaculties(response.data.data);
                setFilteredAdmins(response.data.data);
                setLoading(false);
            } catch (err) {
                setError(err.response?.data?.error || "Failed to fetch faculties.");
                setLoading(false);
            }
        };

        fetchFaculties();
    }, []);
    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);

        const filtered = faculties.filter((faculty) => {
            return (
                faculty.name.toLowerCase().includes(value) ||
                faculty.email.toLowerCase().includes(value) ||
                faculty.organizationAddress?.toLowerCase().includes(value)
            );
        });

        setFilteredAdmins(filtered);
        setCurrentPage(1);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredAdmins.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div className="DeactivateUsers_container">
            <h1>Activate Students</h1>
            <div className="search-bar">
                <input
                    type="text"
                    placeholder="Search by Name, Email, or Organization"
                    value={searchTerm}
                    onChange={handleSearch}
                    className="search-box"
                />
            </div>
            {loading ? (
                <Loader />
            ) : (
                <div className="admin-table-container">
                    {error ? (
                        <div className="error-message">{error}</div>
                    ) : (
                        <>
                            <table className="DeactivateUsers_table">
                                <thead>
                                    <tr>
                                        <th>SL No</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Organization Address</th>
                                        <th>Contact</th>
                                        <th>Gender</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.length > 0 ? (
                                        currentItems.map((faculty, index) => (
                                            <tr key={faculty._id}>
                                                <td>{index + 1 + indexOfFirstItem}</td>
                                                <td>{faculty.name}</td>
                                                <td>{faculty.email}</td>
                                                <td>{faculty.organizationAddress}</td>
                                                <td>{faculty.organizationContact}</td>
                                                <td>{faculty.gender}</td>
                                                <td className={faculty.active ? "active-status" : "deactive-status"}>
                                                    {faculty.active ? "Active" : "Deactive"}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="no-data">No Data Found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="pagination">
                                {filteredAdmins.length > itemsPerPage && (
                                    <ul className="pagination-list">
                                        {[...Array(Math.ceil(filteredAdmins.length / itemsPerPage))].map((_, index) => (
                                            <li key={index + 1}>
                                                <button
                                                    className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
                                                    onClick={() => paginate(index + 1)}
                                                >
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

export default ViewStudents;
